import React, {Component} from 'react';
import ContactInfo, {ICON_MAIL, ICON_PHONE} from "../contactInfo";

import './style.css';

export default class Contact extends Component {
    render() {
        return (
            <div className="Contact">
                <h2 className="Contact__title">{"Kontaktní informace"}</h2>
                <div className="row vertical-align">
                    <div className="col-md-4 order-md-2 Contact__row">
                        <h3 className="Contact__name">Ing. et Ing. Pavel Dostál</h3>
                        <div>U Letiště 232, <br/> 549 01 Nové Město nad Metují</div>
                        <div>IČ: 07385731</div>
                    </div>
                    <div className="col-md-4 order-md-1 Contact__row">
                        <ContactInfo icon={ICON_PHONE} children={<a href="tel:606619281">+420 606 619 281</a>}/>
                    </div>
                    <div className="col-md-4 order-md-3 Contact__row">
                        <ContactInfo icon={ICON_MAIL} children={<a href="mailto:info@zahradydostal.cz">info@zahradydostal.cz</a>}/>
                    </div>
                </div>
            </div>
        );
    }
}